<template>
  <div class="sub_search_wrap-contents_area">
    <div class="sub_search-contents_titwrap">
      <div class="sub_contents-tit">
        <span v-on:click="close" class="sub_contents_close">×</span>
        <span class="sub_contents_tit_txt">詳細検索</span>
        <span v-on:click="additionalConditionsStore.clear()" class="sub_contents_tit_clear">すべてクリア</span>
      </div>
    </div>

    <div class="sub_search-contents_area">
      <div class="sub_search-contents_table sub_search-contents_table_internship">
        <table class="m3-table m3-table-search-toggle m3-table-search-toggle_detailedsearch">
          <tbody>
            <tr>
              <BusinessComponent />
              <MonthComponent />
              <HoldDaysComponent />
              <RegionComponent />
              <FeatureComponent />
              <WorkContentComponent />
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="sub_search-fixbtnbox">
      <ul class="sub_search-btn">
        <li><button type="submit" class="link_btn_green">検索する</button></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { inject, onMounted } from 'vue'
import BusinessComponent from './business'
import MonthComponent from './month'
import HoldDaysComponent from './hold_days'
import RegionComponent from './region'
import FeatureComponent from './feature'
import WorkContentComponent from './work_content'
import { setupModal } from '@component_path/lib/modal.js'
setupModal('.sub_search-contents_area')

// 選択された重要ラベルがファーストビューで見えるようにモーダル内をスクロールする
const props = defineProps({
  scrollIntoView: { type: Function, required: true }
})
const emit = defineEmits(['close'])
const additionalConditionsStore = inject('additionalConditionsStore')

const close = () => {
  additionalConditionsStore.reset()
  emit('close')
}

onMounted(() => {
  props.scrollIntoView()
})
</script>
